"use client";

import React, { useState, useEffect } from "react";
import { 
  Box, 
  Flex, 
  Heading, 
  Text, 
  Badge, 
  Image, 
  HStack, 
  VStack,
  IconButton,
  Container,
  SlideFade,
  Button,
  useToast,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure
} from "@chakra-ui/react";
import { EditIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import { authService } from "../../services/authService";

interface UserHeaderProps {
  onClose?: () => void;
  executiveData?: {
    name: string;
    position: any;
    avatar: string;
    email: string;
    team: string;
    id: any;
  };
}

const UserHeader: React.FC<UserHeaderProps> = ({ onClose, executiveData }) => {
  console.log('salessssss',executiveData);
  
  const [showContent, setShowContent] = useState(false);
  const toast = useToast();
  const { isOpen, onOpen, onClose: onCloseDialog } = useDisclosure();
  const cancelRef = React.useRef<HTMLButtonElement>(null);
  // Initialize animation
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 50);
    
    return () => clearTimeout(timer);
  }, []);

  const handleLogout = async () => {
      if (!executiveData?.email || !executiveData?.id) {
          toast({
              title: 'Error',
              description: 'Missing salesperson email or ID.',
              status: 'error',
              duration: 5000,
              isClosable: true,
              position: 'top',
          });
          return;
      }

      try {
          await authService.forceLogoutSalesPerson(executiveData.email, executiveData.id);
          toast({
              title: 'Success',
              description: `Salesperson ${executiveData.name} has been logged out successfully.`,
              status: 'success',
              duration: 4000,
              isClosable: true,
              position: 'top',
          });
          onCloseDialog();
      } catch (error) {
          toast({
              title: 'Error',
              description: 'Failed to log out salesperson. Please try again.',
              status: 'error',
              duration: 5000,
              isClosable: true,
              position: 'top',
          });
      }
  };

  const handleLogoutClick = () => {
      onOpen();
  };
  
  const data = executiveData || {
    name: "Rishabh Patel",
    position: "Senior Sales Rep",
    team: "Noida",
    email: "rishabh@xai.com",
    avatar: "https://cdn.builder.io/api/v1/image/assets/TEMP/d91706ac1d6e14463933b5d208c40ae34235e350?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
  };
  
  return (
    <Box as="header" overflow="hidden" px="1px" bg="gray.100" w="full">
      <Container maxW="container.xl" py={4}>
        <SlideFade in={showContent} offsetY="-20px" transition={{ enter: { duration: 0.4 } }}>
          <Flex wrap="wrap" gap="10" justifyContent="space-between" alignItems="center" w="full">
            <Flex gap="2" alignItems="center" minW="240px">
              <Image
                src={data.avatar}
                objectFit="cover"
                flexShrink={0}
                alignSelf="center"
                w="90px"
                h="90px"
                borderRadius="full"
                alt="User profile"
              />
              <VStack alignItems="flex-start" spacing={2} justifyContent="center" minW="240px">
                <HStack>
                  <Heading alignSelf="stretch" fontSize="2xl" color="blue.900">
                    {data.name}
                  </Heading>
                  <Badge 
                    alignSelf="stretch" 
                    px="2" 
                    py="1"
                    fontSize="xs" 
                    color="green.500" 
                    borderRadius="sm" 
                    bg="green.50"
                  >
                    Active
                  </Badge>
                  <Button
                    size="m"
                    variant="unstyled"
                    rightIcon={<ExternalLinkIcon />}
                    onClick={handleLogoutClick}
                    marginStart={10}
                    // mb={2}
                    h="20px"
                    color="red.600"
                    _hover={{ opacity: 0.8, cursor: "pointer" }}
                  >
                    Logout
                  </Button>
                </HStack>
                <HStack fontSize="xs" color="gray.500" spacing={2}>
                  <Flex gap="1" alignItems="center" px="2" py="1" borderRadius="sm">
                    <Image
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/b5573f47f7ad2c6d8636c59e8017cf5f71172722?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
                      objectFit="contain"
                      flexShrink={0}
                      alignSelf="center"
                      w="4"
                      h="4"
                      alt="Role icon"
                    />
                    <Text>{data.position}</Text>
                  </Flex>
                  {/* <Flex gap="1" alignItems="center" px="2" py="1" borderRadius="sm">
                    <Image
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/66626330bd8d422fc11f9d1ae322336ea63b246f?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
                      objectFit="contain"
                      flexShrink={0}
                      alignSelf="center"
                      w="3"
                      h="3"
                      alt="Team icon"
                    />
                    <Text>Team:</Text>
                    <Text>{data.team}</Text>
                  </Flex> */}
                  <Flex gap="1" alignItems="center" px="2" py="1" borderRadius="sm">
                    <Image
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/f851877c62602b20705bc6635d309982a79942f9?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
                      objectFit="contain"
                      flexShrink={0}
                      alignSelf="center"
                      w="3"
                      h="3"
                      alt="Email icon"
                    />
                    <Text>{data.email}</Text>
                  </Flex>
                </HStack>
              </VStack>
            </Flex>
            
            <HStack spacing={3}>
              {/* <IconButton
                aria-label="Edit"
                icon={<Image
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/fce38c42b164daba93905a64846b8b9624334668?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
                  objectFit="contain"
                  w="20px"
                  h="20px"
                  alt="Edit"
                />}
                size="sm"
                variant="unstyled"
                minW="auto"
                height="auto"
              /> */}
              <IconButton
                aria-label="Close"
                icon={<Image
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/82ae17edeaa925b21e8e32fc9e23ac0045edfb9c?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
                  objectFit="contain"
                  w="19px"
                  h="19px"
                  alt="Close"
                />}
                size="sm"
                variant="unstyled"
                minW="auto"
                height="auto"
                onClick={onClose}
                _hover={{ opacity: 0.8, cursor: "pointer" }}
              />
            </HStack>
          </Flex>
        </SlideFade>
      </Container>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onCloseDialog}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Logout
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to log out {executiveData?.name || 'this salesperson'}? This action cannot be undone.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseDialog}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleLogout} ml={3}>
                Logout
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default UserHeader; 